var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHowSvg4({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 7.45117L7 9.97376V15.9296C6.94666 18.1802 9.55599 20.1961 11.9987 22.2654",
    stroke: "#4D4E99",
    strokeWidth: 1.99997,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9742 14.3065L13.3328 16.7224C13.4817 16.8752 13.6591 16.9971 13.8551 17.0813C14.0511 17.1655 14.2617 17.2103 14.4749 17.2131C14.6882 17.2158 14.8999 17.1766 15.098 17.0976C15.2961 17.0185 15.4767 16.9012 15.6295 16.7524C15.7823 16.6036 15.9042 16.4261 15.9884 16.2302C16.0726 16.0342 16.1174 15.8236 16.1201 15.6103C16.1229 15.3971 16.0837 15.1854 16.0046 14.9873C15.9256 14.7892 15.8083 14.6086 15.6595 14.4558L11.9915 10.7133V8.76266C11.7928 7.59383 11.3483 6.48046 10.6875 5.49609",
    stroke: "#4D4E99",
    strokeWidth: 1.99997,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 15.3477V31.4965C12 32.0269 12.2107 32.5356 12.5858 32.9107C12.9609 33.2857 13.4696 33.4964 14 33.4964H24",
    stroke: "#4D4E99",
    strokeWidth: 1.99997,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9997 33.5386L32.9997 31.016V25.0615C33.0463 23.1163 31.105 21.347 28.9997 19.5684V26.6588L26.6664 24.2695C26.3658 23.961 25.955 23.7845 25.5242 23.7789C25.0935 23.7733 24.6782 23.939 24.3697 24.2396C24.0612 24.5401 23.8847 24.9509 23.879 25.3816C23.8734 25.8123 24.0391 26.2276 24.3397 26.5361L28.013 30.28V32.2293C28.2127 33.3962 28.6571 34.5076 29.317 35.4905",
    stroke: "#4D4E99",
    strokeWidth: 1.99997,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M21.304 28.4961H16",
    stroke: "#4D4E99",
    strokeWidth: 1.99997,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M18 23.4961H16",
    stroke: "#4D4E99",
    strokeWidth: 1.99997,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M31 11.4959C31 12.6826 30.6481 13.8426 29.9888 14.8292C29.3295 15.8159 28.3924 16.5849 27.2961 17.039C26.1997 17.4931 24.9933 17.6119 23.8295 17.3804C22.6656 17.1489 21.5965 16.5775 20.7574 15.7384C19.9182 14.8993 19.3468 13.8303 19.1153 12.6664C18.8838 11.5026 19.0026 10.2962 19.4567 9.19988C19.9108 8.10356 20.6799 7.16651 21.6666 6.50725C22.6533 5.84798 23.8133 5.49609 25 5.49609",
    stroke: "#4D4E99",
    strokeWidth: 1.99997,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M30.9981 6.99609L25.5314 12.4626C25.4615 12.5329 25.3784 12.5887 25.2869 12.6268C25.1954 12.6648 25.0972 12.6844 24.9981 12.6844C24.899 12.6844 24.8008 12.6648 24.7093 12.6268C24.6177 12.5887 24.5346 12.5329 24.4648 12.4626L22.7461 10.7426",
    stroke: "#4D4E99",
    strokeWidth: 1.99997,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHowSvg4);
export default __webpack_public_path__ + "static/media/howSVG4.140a1ebf08858508657e819cd84fe399.svg";
export { ForwardRef as ReactComponent };